module.exports = __webpack_public_path__ + "static/media/IconTemplates_-95.ffe3e876.svg";